import { GetterNames } from './keys'
import { ExerciseProgramState, FlatExerciseProgram, FlatExerciseProgramSession } from './types'
import { flattenJsonApiResponse } from '@/store/utils/converter'

export const getters = {
  [GetterNames.exercisePrograms]: (state: ExerciseProgramState): FlatExerciseProgram[] => {
    return state.exercisePrograms.map(flattenJsonApiResponse).sort((a, b) => b.createdTimestamp - a.createdTimestamp)
  },

  [GetterNames.chosenExerciseProgram]: (state: ExerciseProgramState): FlatExerciseProgram => {
    return state.exercisePrograms
      .map(flattenJsonApiResponse)
      .find(program => program.id === state.chosenExerciseProgramId)
  },

  [GetterNames.chosenExerciseProgramId]: (state: ExerciseProgramState): string => {
    return state.chosenExerciseProgramId
  },

  [GetterNames.chosenExerciseProgramSessions]: (state: ExerciseProgramState): FlatExerciseProgramSession[] => {
    return state.exerciseProgramSessions
      .map(flattenJsonApiResponse)
      .filter(session => session.programId === state.chosenExerciseProgramId)
  },
}
